import { EventDispatcher } from './EventDispatcher';
import { Subject } from '../Model/core';

export const tagEventHandler = new EventDispatcher<Subject | undefined>();